// frontend/src/pages/MyFeed.js
import React, { useEffect, useState } from 'react';
import axios, { PUBLIC_BASE } from '../utils/axiosInstance';
import ListCard from '../components/ListCard';

// Normalize possible DB image values into a usable URL
const toImageUrl = (raw) => {
  if (!raw) return '';
  if (typeof raw === 'string' && /^https?:\/\//i.test(raw)) return raw; // absolute
  const s = String(raw);
  const path = s.startsWith('/') ? s : `/${s}`;
  return `${PUBLIC_BASE}${path}`;
};

export default function MyFeed() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setErr('');
        // backend returns newest-first already
        const { data } = await axios.get('/users/me/feed', { params: { limit: 60 } });
        if (!alive) return;
        const rows = Array.isArray(data?.items) ? data.items : [];
        setItems(
          rows.map((r) => ({
            listId: r.listId,
            listName: r.listName || 'Unknown List',
            listImage: toImageUrl(r.listImage),
            rankedBy: r.rankedBy,
            hasMine: !!r.hasMine,            // backend provides this
            similarity: r.similarity,        // number or null
            updatedAt: r.updatedAt,
          }))
        );
      } catch {
        if (!alive) return;
        setErr('Failed to load feed.');
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div className="scroll-shell">
      <div className="scroll-body">
        {err && <div style={{ color: '#b91c1c', marginBottom: 12 }}>{err}</div>}

        {/* Match other pages' spacing (no "My Feed" heading) */}
        <div className="grid-divider" aria-hidden="true" />

        <div className="grid">
          {items.map((it) => {
            // Left footer: small, unbold, gray; expands naturally and ellipsizes only as needed
            const footerLeft = (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: 6,
                  flex: 1,       // take remaining space
                  minWidth: 0,   // allow inner text to shrink for ellipsis
                  paddingRight: 8
                }}
              >
                <span
                  style={{
                    fontWeight: 400,
                    fontSize: 12,
                    color: '#8a94a6',
                    flex: '0 0 auto',
                  }}
                >
                  Ranked by:
                </span>
                <span
                  style={{
                    fontWeight: 400,
                    fontSize: 12,
                    color: '#8a94a6',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block',
                    flex: 1,
                    minWidth: 0,
                  }}
                  title={it.rankedBy}
                >
                  {it.rankedBy}
                </span>
              </div>
            );

            // Only show similarity if you’ve ranked this list too AND it’s numeric
            const showSimilarity = it.hasMine === true && Number.isFinite(Number(it.similarity));

            return (
              <ListCard
                key={`${it.listId}-${it.rankedBy}-${it.updatedAt}`}
                to={`/friends/${encodeURIComponent(it.rankedBy)}/rankings/${it.listId}`}
                title={it.listName}
                imageUrl={it.listImage}
                subtitle="" // we override the left footer entirely
                badgeRight={showSimilarity ? `Similarity: ${Math.round(Number(it.similarity))}%` : undefined}
                footerLeftOverride={footerLeft}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
